"use strict";

var agendorAPI = require("app/util/api/agendor-api");

module.exports.get = function get(sessionId, id, cb) {
	agendorAPI.sessionId = sessionId;
	agendorAPI.get("/organizations/"+ id + "?address_to_string=true", null, cb);
};


// WEBPACK FOOTER //
// ./app/util/api/organizations.js